'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommentMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isCommentMessage = exports.isCommentMessage = (0, _isType.isType)(_messageTypes.THREAD_COMMENT);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isCommentMessage.js
// module id = 746
// module chunks = 2 3